import { Injectable } from '@angular/core';
import * as introJs from 'intro.js/intro.js';

// Extracted from HomeComponent, which had grown to own navigation, search, the PWA
// install prompt, two modals, the billing check, online status and this tour.
// The steps are keyed off element ids that live in the navigation template, so this
// moves the logic out without touching any markup.
@Injectable({
  providedIn: 'root',
})
export class ProducttourService {
  private introJS = introJs();

  private readonly baseSteps = [
    { element: '#step0', intro: 'Takes you to your <b>Dashboard</b>', position: 'right' },
    { element: '#step2', intro: 'Takes you to <b>School Dashboard</b>', position: 'left' },
    { element: '#step4', intro: 'Take tour of Page', position: 'right' },
    {
      element: '#searchcourses1',
      intro:
        "Type <b>course code</b> or <b>course name</b> to search for course among registered courses or all the school's courses",
      position: 'bottom',
    },
    { element: '#profiledd', intro: 'Click to View Profile or Logout', position: 'bottom' },
  ];

  private readonly adminSteps = [
    { element: '#step1', intro: 'Click to View Admin Options', position: 'left' },
    { element: '#step3a', intro: 'Setup School Infomation', position: 'top' },
    { element: '#step3', intro: 'View/Setup School Account Details, and School Plan', position: 'top' },
    { element: '#stepbilling', intro: 'View Daily/Monthly Billings', position: 'top' },
    { element: '#collectionsLink', intro: 'View Payments Received ', position: 'top' },
    { element: '#step40', intro: 'School Packages', position: 'top' },
  ];

  start(showBilling: boolean, extraSteps: any[] = []) {
    const steps = showBilling
      ? [...this.baseSteps, ...this.adminSteps]
      : [...this.baseSteps];

    // a step whose element is not on the page makes intro.js jump to the top-left,
    // so only keep the ones actually rendered
    const enabledSteps = steps.filter(step => document.querySelector(step.element));

    this.introJS.setOptions({
      steps: enabledSteps,
      showProgress: false,
      exitOnOverlayClick: true,
      exitOnEsc: true,
      skipLabel: 'Exit',
    });
    this.introJS.addSteps(extraSteps);
    this.introJS.start();
  }
}
